import "katex/dist/katex.min.css";

import Latex from "react-latex-next";
import { Fragment } from "react";

import type { FC } from "react";

import { AnswerPractice } from "components";

import type { IAssignmentResult } from "store/slices/topicPractice";

import { ABCDOptionText } from "utils/formatTextForAnalysis";
import { AssignmentPrompt } from "components/AssignmentPrompt";

interface Props {
  assignmentResult: IAssignmentResult;
  toggleModals: (showQuestionAnalysisIndex: number | null) => void;
}

const ABCD: FC<Props> = ({ assignmentResult, toggleModals }) => {
  const { assignment } = assignmentResult.assignment;
  if (assignment === undefined || assignment === null) return null;

  return (
    <>
      <AssignmentPrompt assignment={assignment?.assignment} />

      {assignment.assignment?.questions.map((question, qIndex) => (
        <Fragment key={`answer-${qIndex}`}>
          <Latex>{question.heading ?? ""}</Latex>

          <AnswerPractice
            index={qIndex}
            assignment={assignment}
            type={assignmentResult.answerVariants?.[qIndex]}
            toggleModals={toggleModals}
            showBackOnSolution={true}
            userAssignmentId={assignmentResult.assignment.id}
          >
            {ABCDOptionText(assignmentResult.userAnswers[qIndex])}
          </AnswerPractice>
        </Fragment>
      ))}
    </>
  );
};

export default ABCD;
